import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n';

export const FormTitle = ({ title, isRequired }) => {
  return (
    <div className="form-section-title">
      <h2>{i18n.t(title)}</h2>
      {isRequired && <>*{i18n.t('MB_T_INFO_REQ')}</>}
    </div>
  );
};
FormTitle.propTypes = { title: PropTypes.string, isRequired: PropTypes.bool };
FormTitle.defaultProps = { title: '', isRequired: false };
export default FormTitle;
